import { capitalize } from '@codeleap/common'
import { IsDevEnv } from './Settings'
import { faker } from '../utils/faker'

const fakeEmail = `tester+${faker.animal()}_${faker.number(0, 100)}@codeleap.co.uk`
const fakeFirst = `${faker.firstName()}`
const fakeLast = `${faker.lastName()}`

export const fakeProfile = {
  email: IsDevEnv ? fakeEmail : '',
  password: IsDevEnv ? 'Codeleap123' : '',
  repeatPassword: IsDevEnv ? 'Codeleap123' : '',
  avatar: IsDevEnv ? null : null,
  first_name: IsDevEnv ? fakeFirst : '',
  last_name: IsDevEnv ? fakeLast : ''
}

const _testers = {
  default: {
    email: 'tester@codeleap.co.uk',
    password: 'Codeleap123'
  },
  random: fakeProfile
}

const mailList = ['paulo', 'gabriel', 'felipe', 'victor', 'vini', 'fernando', 'leo', 'lucas', 'kenzo'].sort((a, b) =>
  a.localeCompare(b)
)

mailList.forEach(person => {
  _testers[person] = {
    email: `${person}@codeleap.co.uk`,
    password: 'Codeleap123',
    first_name: capitalize(person),
    last_name: 'Codeleap'
  }
})

export const testers = _testers

export const testerOptions = Object.keys(_testers).map(testerId => {
  return {
    value: testerId,
    label: capitalize(testerId)
  }
})
